import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TCourseKyoriTarihuGetListReq,
  TCourseKyoriTarihuGetListRes,
  TCourseKyoriTarihuListInfoGetRes,
  TCourseKyoriTarihuPutReq,
} from "./TCourseKyoriTarihu"

/**
 * コース距離タリフに対するAPIリクエスト用サービス
 *
 * @export
 * @class CourseKyoriTarihuService
 * @extends {ConnectApi}
 */
export default class CourseKyoriTarihuService extends ConnectApi {
  /**
   * 一覧取得
   * @returns
   */
  getListInfo = async () => {
    try {
      return {
        data: 一覧dummy,
      }
    } catch (err) {
      throw err
    }
  }

  /**
   * コース距離タリフ 一覧取得
   *
   * @param {TCourseKyoriTarihuGetListReq} params
   * @param {(param: TApiResponse<TCourseKyoriTarihuGetListRes>) => any} resolve
   * @param {(param: TApiResponse<TCourseKyoriTarihuGetListRes>) => any} reject
   * @memberof CourseKyoriTarihuService
   */
  getList = async (params: TCourseKyoriTarihuGetListReq) => {
    try {
      // const res: AxiosResponse<TApiResponse<TZyomuinListGetRes>> =
      // await this.getInner(`/master/hinmei`, params)
      //return res.data
      //   if (params.年月 === "2" && params.品コード === "1") {
      //     // eslint-disable-next-line no-throw-literal
      //     throw "ERROR"
      //   }

      if (params.荷主コード === "100001") {
        return {
          data: コース距離タリフ一覧dummyList_1,
        }
      } else if (params.荷主コード === "100002") {
        return {
          data: コース距離タリフ一覧dummyList_2,
        }
      } else {
        return {
          data: コース距離タリフ一覧dummyList_3,
        }
      }

      //TODO: api実装必要
    } catch (err) {
      throw err
    }
  }

  /**
   * コース距離タリフ 更新
   *
   * @param {TCourseKyoriTarihuPutReq} data
   * @param {(param: TApiResponse<TCourseKyoriTarihuGetListRes[]>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TCourseKyoriTarihuGetListRes[]>>) => any} reject
   * @memberof CourseKyoriTarihuService
   */
  put = async (data: TCourseKyoriTarihuPutReq[]) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `billing/CourseKyoritarihu/list`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}

//TODO:ダミーデータ
const 一覧dummy: TCourseKyoriTarihuListInfoGetRes[] = [
  {
    荷主ID: 1,
    荷主コード: "100001",
    荷主名: "アーステック株式会社",
  },
  {
    荷主ID: 2,
    荷主コード: "100002",
    荷主名: "アサヒロジ株式会社",
  },
]

const コース距離タリフ一覧dummyList_1: TCourseKyoriTarihuGetListRes = {
  荷主ID: 1,
  コース距離タリフ明細: [
    {
      コース距離タリフid: 1,
      積地_id: 1,
      積地_コード: "11111",
      積地_社名: "AAAA社名",
      積地_都道府県コード: "00002",
      積地_都道府県名称: "山口県",
      積地_市区町村: "渡辺市三宅町廣川",
      卸地_id: 1,
      卸地_コード: "22222",
      卸地_社名: "BBBB社名",
      卸地_都道府県コード: "00002",
      卸地_都道府県名称: "山口県",
      卸地_市区町村: "渡辺市三宅町廣川",
      運賃単価設定区分: "1",
      車種区分: "1",
      銅種コード: "1",
      銅種名: "KK",
      距離: 1000,
      単価: 12000,
      更新日時: "2022-01-01T00:00:00",
      modifyToken: "2022-02-01T00:00:00",
    },
    {
      コース距離タリフid: 2,
      積地_コード: "11111",
      積地_id: 2,
      積地_社名: "AAAA社名22",
      積地_都道府県コード: "00002",
      積地_都道府県名称: "山口県",
      積地_市区町村: "渡辺市三宅町廣川",
      卸地_id: 1,
      卸地_コード: "22222",
      卸地_社名: "BBBB社名",
      卸地_都道府県コード: "00002",
      卸地_都道府県名称: "山口県",
      卸地_市区町村: "渡辺市三宅町廣川",
      運賃単価設定区分: "2",
      車種区分: "2",
      銅種コード: "4",
      銅種名: "コイル",
      距離: 1000,
      単価: 12000,
      更新日時: "2022-01-01T00:00:00",
      modifyToken: "2022-02-01T00:00:00",
    },
  ],
  更新日時: "2022-01-01T00:00:00",
  modifyToken: "2022-02-01T00:00:00",
}

const コース距離タリフ一覧dummyList_2: TCourseKyoriTarihuGetListRes = {
  荷主ID: 2,
  コース距離タリフ明細: [
    {
      コース距離タリフid: 1,
      積地_id: 1,
      積地_コード: "11111",
      積地_社名: "dummy2社名",
      積地_都道府県コード: "00002",
      積地_都道府県名称: "山口県",
      積地_市区町村: "渡辺市三宅町廣川",
      卸地_id: 1,
      卸地_コード: "22222",
      卸地_社名: "BBBB社名",
      卸地_都道府県コード: "00002",
      卸地_都道府県名称: "山口県",
      卸地_市区町村: "渡辺市三宅町廣川",
      運賃単価設定区分: "1",
      車種区分: "1",
      銅種コード: "1",
      銅種名: "KK",
      距離: 2000,
      単価: 22000,
      更新日時: "2022-01-01T00:00:00",
      modifyToken: "2022-02-01T00:00:00",
    },
  ],
  更新日時: "2022-01-01T00:00:00",
  modifyToken: "2022-02-01T00:00:00",
}
const コース距離タリフ一覧dummyList_3: TCourseKyoriTarihuGetListRes = {
  荷主ID: 3,
  コース距離タリフ明細: [
    {
      コース距離タリフid: 1,
      積地_id: 1,
      積地_コード: "11111",
      積地_社名: "dummy3社名",
      積地_都道府県コード: "00002",
      積地_都道府県名称: "山口県",
      積地_市区町村: "渡辺市三宅町廣川",
      卸地_id: 1,
      卸地_コード: "22222",
      卸地_社名: "BBBB社名",
      卸地_都道府県コード: "00002",
      卸地_都道府県名称: "山口県",
      卸地_市区町村: "渡辺市三宅町廣川",
      運賃単価設定区分: "1",
      車種区分: "1",
      銅種コード: "1",
      銅種名: "KK",
      距離: 3000,
      単価: 32000,
      更新日時: "2022-01-01T00:00:00",
      modifyToken: "2022-02-01T00:00:00",
    },
  ],
  更新日時: "2022-01-01T00:00:00",
  modifyToken: "2022-02-01T00:00:00",
}
